import * as colors from './colors';
export const input = {
  size: '1.6rem',
  color: colors.text.primary,
  disabled: colors.blueGreyBackground[100]
};
export const label = {
  size: '1.6rem',
  color: colors.text.primary,
  disabled: colors.blueGreyBackground[100]
};
export const helper = {
  size: '1.6rem',
  color: colors.text.primary,
  disabled: colors.blueGreyBackground[100]
};
export const placeholder = {
  size: input.size,
  color: colors.blueGreyBackground[100],
  disabled: colors.blueGreyBackground[100]
};
export const border = {
  color: colors.oriGrey.A400,
  hover: colors.oriGrey[700],
  focused: colors.primary.main,
  disabled: colors.blueGreyBackground[100]
};
export const background = {
  hover: colors.action.hover
};
export const inputFontSizes = {
  input: {
    mobile: input.size
  },
  'input-label': {
    mobile: label.size
  },
  'input-helper': {
    mobile: helper.size
  }
};
//# sourceMappingURL=textInputData.js.map